const baseApiUrl = process.env.VUE_APP_MAIN_DOMAIN_URL

export const GET_MAIN_CATEGORIES = async () => {
 const response = await fetch(`${baseApiUrl}/shop/categories/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result
}

export const GET_CATEGORY_BY_ID = async (id) => {
 const response = await fetch(`${baseApiUrl}/shop/categories/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result
}


export const GET_ALL_PRODUCTS = async () => {
 const response = await fetch(`${baseApiUrl}/shop/products/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result
}

export const GET_ONE_PRODUCT = async (product) => {
   const response = await fetch(`${baseApiUrl}/shop/products/${product}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result  
}

export const GET_ALL_CUSTOMERS = async () => {
  const response = await fetch(`${baseApiUrl}/customers/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}

export const GET_ONE_CUSTOMER = async (id) => {
  const response = await fetch(`${baseApiUrl}/customers/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}

export const SET_EDIT_CUTOMER_NAME = async (id, name, reminder_new, reminder_favorite, timezone ) => {
  const response = await fetch(`${baseApiUrl}/customers/${id}/update`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
     body: JSON.stringify({
      name,
      reminder_new,
      reminder_favorite,
      timezone
    })
  })
  const result = await response.json()
  return result 
}



export const GET_CUSTOMER_REFERER_LINK = async (id) => {
  const response = await fetch(`${baseApiUrl}/customers/${id}/referer-link`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}

export const GET_FAVORITES_PRODUCTS = async (customer_id) => {
  const response = await fetch(`${baseApiUrl}/shop/products/${customer_id}/favorites`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}


export const ADD_PRODUCT_TO_FAVORITE = async (customer_id, product_id) => {
  const response = await fetch(`${baseApiUrl}/shop/products/${customer_id}/favorites/add/${product_id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}

export const DELETE_FAVORITE_PRODUCT = async (customer_id, product_id) => {
  const response = await fetch(`${baseApiUrl}/shop/products/${customer_id}/favorites/remove/${product_id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
  const result = await response.json()
  return result 
}


export const GET_SHOP_PRODUCTS_SEARCH = async ({q = '', category_ids = null, sort = ''}) => {
   const response = await fetch(`${baseApiUrl}/shop/products/search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    },
    body: JSON.stringify({
      search: q,
      category_ids,
      sort
    })
  })
  const result = await response.json()
  return result  
}

export const GET_TIMEZONES = async () => {
   const response = await fetch(`${baseApiUrl}/timezones`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Cache-Control': 'no-cache',
    }
  })
  const result = await response.json()
  return result  
}
